var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"viewerContainer",staticClass:"pdf-viewer-container"})}
var staticRenderFns = []
export { render, staticRenderFns }